import { getDomain } from '../config';

const domain = getDomain();

export const BASENAME = '/design/tools-software/product-recommendation-tools-plus';

export const COOKIES = {
	POLICY_CONSENT: 'prt_policyConsent',
	TOKEN: 'myon-access-token'
};

export const PAGE_TITLE = 'Product Recommendation Tool+';

export const SUPPORT_EMAIL = 'recommendation.tools@onsemi.com?subject=Product Recommendation Tools (PRT+)';

export const URL = {
	ONSEMI: `https://www.${domain}`,
	PRT_PLUS: `https://www.${domain}/design/tools-software/product-recommendation-tools-plus`,
	PRODUCT_PAGE: `https://www.${domain}/PowerSolutions/product.do?id=`,
	DATASHEET: `https://www.${domain}/download/data-sheet/pdf/`,
	LEGACY_TOOLS: `https://www.${domain}/support/product-recommendation-tool`,
	DESIGN_TOOLS: `https://www.${domain}/design-tools/inputs?`,
	SALES_SUPPORT: `https://www.${domain}/support/sales`,
	COMMUNITY_FORUM: `https://community.onsemi.com/s/topicanddiscussion`,
	NEED_A_GATE_DRIVER: `https://www.${domain}/design/tools-software/product-recommendation-tools-plus/gate-driver/products`,
	GATE_DRIVERS_OPTOCOUPLERS: `https://www.${domain}/products/interfaces/igbt-mosfet-gate-drivers-optocouplers#products=fnN0YXR1c352YWx1ZX4xfiF+TGFzdCBTaGlwbWVudHN+`,
	DESIGN_PAGE: `https://www.${domain}/design`
};
